// See docs/loadable-components.md for details regarding **.imports-X.** file extension & duplicate file structure.
import React from 'react';
import loadable from '@loadable/component';
import retry from '~/utils/retry';
import Loading from '~/shared/Loading';

const GetWaitlistContainer = loadable(() => retry(() => import('./GetWaitlistContainer')), {
  fallback: <Loading size="fullscreen" />,
  resolveComponent: module => module.GetWaitlistContainer,
});

export default GetWaitlistContainer;
